import { Observable } from "rxjs";

import HttpFactory from "./abstract/abstract.api.service";
import { apiRoutes } from "./routes";

export class EventsService {
    static getLastEvents(numberOfEvents: number): Observable<any> {
        return HttpFactory.GET([apiRoutes.lastEvents, "last_" + numberOfEvents].join('/'));
    }
}